import { reactive, toRef } from 'vue'
import { Toast, Dialog } from 'vant'
import api from '@/api'
import globalVariables from '@/utils/globalVariables'


export default function useLogin() {
    const data = reactive({
        hadLogin: false,
        isLoginPopupVisble: false,
        username: '',
        mobile: '',
        credentials: ''
    })

    const user = globalVariables.getUserInfo(globalVariables.getProjectCode())
    if (user.customerID !== '-1') {
        data.hadLogin = true
        data.username = user.username
    }

    const onPopupLogin = () => {
        data.isLoginPopupVisble = true
    }

    const onMobileInput = e => {
        const value = e.target.value.toString()
        if (value.length > 6) {
            data.mobile = value.slice(0, 6)
            return
        }
        data.mobile = value
    }

    const onCredentialsInput = e => {
        const value = e.target.value.toString()
        if (value.length > 6) {
            data.credentials = value.slice(0, 6)
            return
        }
        data.credentials = value
    }

    const validateLogin = (action) =>
        new Promise((resolve) => {
            if (action === 'confirm') {
                if (!data.username) {
                    Toast('请输入用户名')
                    resolve(false);
                    return
                }
                if (!data.mobile) {
                    Toast('请输入华夏卡预留手机后六位')
                    resolve(false);
                    return
                }
                if (!data.credentials) {
                    Toast('请输入华夏卡开户证件后六位')
                    resolve(false);
                    return
                }

                if (data.mobile.toString().length !== 6) {
                    resolve(false);
                    Toast('华夏卡预留手机只需输入后六位')
                    return
                }
                if (data.credentials.toString().length !== 6) {
                    resolve(false);
                    Toast('华夏卡开户证件只需输入后六位')
                    return
                }
                resolve(true);
            } else {
                resolve(true);
            }
        });

    const onLogin = async () => {
        const valid = await validateLogin('confirm')
        console.log('valid', valid)
        if (!valid) return

        const res = await api.userlogin({
            name: data.username,
            mobile: data.mobile,
            cardNum: data.credentials,
            openid: globalVariables.getOpenid()
        })
        if (res.error) {
            Toast(res.error.message)
            return
        }
        const { token, id } = res.data
        globalVariables.setUserInfo({
            token,
            customerID: id,
            username: data.username
        }, globalVariables.getProjectCode())

        const user = globalVariables.getUserInfo(globalVariables.getProjectCode())
        if (user.customerID !== '-1') {
            data.hadLogin = true
            data.username = user.username
        } else {
            data.hadLogin = false
        }

    }

    const onPopupLogout = () => {
        Dialog.confirm({
            title: '退出',
            message:
                '您确定要退出吗',
        })
            .then(() => {
                globalVariables.setUserInfo('', globalVariables.getProjectCode())
                const user = globalVariables.getUserInfo(globalVariables.getProjectCode())
                if (user.customerID !== '-1') {
                    data.hadLogin = true
                    data.username = user.username
                } else {
                    data.hadLogin = false
                }
            });

    }

    return {
        hadLogin: toRef(data, 'hadLogin'),
        isLoginPopupVisble: toRef(data, 'isLoginPopupVisble'),
        username: toRef(data, 'username'),
        mobile: toRef(data, 'mobile'),
        credentials: toRef(data, 'credentials'),
        validateLogin,
        onPopupLogin,
        onMobileInput,
        onCredentialsInput,
        onLogin,
        onPopupLogout
    }
}